(async () => {
    if (!customElements.get("featured-benefit")) {
        class featuredbenefit extends HTMLElement {
            constructor() {
                super();
                this.swiperElement = this.querySelector("[data-swiper-featured-benefit-slider]");
                this.swiperOptions = {
                    loop: false,
                    autoplay: false,
                    slidesPerView: 4,
                    direction: "horizontal",
                    observer: false,
                    resizeEvent: "auto",
                    breakpoints: {
                        320: {
                            slidesPerView: 1.4,
                            spaceBetween: 15
                        },
                        768: {
                            slidesPerView: 2.2,
                            spaceBetween: 20
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 20
                        },
                        1440: {
                            slidesPerView: 4,
                            spaceBetween: 20
                        }
                    }
                };
                if (this && this.dataset && this.dataset.options) {
                    const jsonOptions = JSON.parse(this.dataset.options);
                    if (jsonOptions) {
                        this.swiperOptions = {
                            ...this.swiperOptions,
                            ...jsonOptions
                        }
                    }
                }
                if (Shopify.designMode && this.swiperInstance) {
                    window.addEventListener("shopify:section:load", (() => {
                        this.swiperInstance.update()
                    }))
                }
                this.init()
            }
            init() {
                this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions)
            }
        }
        window.featuredbenefit = featuredbenefit;
        customElements.define("featured-benefit", featuredbenefit)
    }
})();
//# sourceMappingURL=featured-benefit.js.map